<template>
  <section class="custom-dashboard-notifications">
    <div class="mr-2 mt-1 d-flex" style="justify-content: space-between">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
        "
      >
        <div>
          <b class="ml-1">{{ component.component_name }}</b>
        </div>
        <div
          v-if="!loading"
          @click="getNecessaryInfo(true)"
          style="cursor: pointer"
        >
          <i class="el-icon-refresh"></i>
        </div>
      </div>
      <div>
        <el-dropdown trigger="click" v-if="!hide_options">
          <el-link
            icon="el-icon-more"
            :underline="false"
            style="transform: rotate(90deg); height: 40px"
          ></el-link>
          <el-dropdown-menu slot="dropdown">
            <a @click="editComponent">
              <el-dropdown-item>Edit</el-dropdown-item>
            </a>
            <a @click="deleteComponent">
              <el-dropdown-item>Delete</el-dropdown-item>
            </a>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div
      class="notifications-container"
      v-loading="loading"
      v-if="notificationsData.length"
    >
      <div class="scroll-container">
        <div class="mb-1 mr-1 ml-1">
          <div
            v-for="(notification, index) in notificationsData"
            :key="index"
            @click="redirect(notification)"
          >
            <el-card
              class="custom-card"
              :style="`margin-bottom: 5px; border-radius: 3px; background-color:${hexToRgb(
                notification.background_color,
                0.1
              )}; border: 0.1px solid ${notification.background_color}`"
            >
              <div class="d-flex">
                <div
                  :style="{
                    '--icon-color': notification.background_color,
                    display: 'flex',
                    'align-items': 'center',
                    padding: '8px',
                    'background-color': hexToRgb(
                      notification.background_color,
                      0.15
                    ),
                    'border-radius': '5px',
                  }"
                  class="notification-icon"
                >
                  <icons :iconName="notification.icon"></icons>
                </div>
                <div class="ml-1">
                  <h4 style="font-size: 14px">
                    {{ notification.heading | truncate(47, "...") }}
                  </h4>
                  <p
                    style="font-size: 12px"
                    v-html="notification.custom_message"
                  ></p>
                </div>
                <div class="flex-grow-1 text-right">
                  <span class="date-time text-dark fw-medium pl-0 opacity-80">{{
                    getNotificationTime(notification)
                      | getFormattedDateTypeThree
                  }}</span>
                </div>
              </div>
            </el-card>
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              text-align: center;
              font-size: 16px;
              font-weight: bold;
            "
            v-if="hasMore"
            @click="loadMore"
          >
            {{ loadMoreText }}
          </div>
        </div>
      </div>
    </div>
    <div v-else v-loading="loading">
      <el-empty description="No Notifications"></el-empty>
    </div>
  </section>
</template>
<script>
import { postAPICall } from "../../helpers/httpHelper";
import FieldStylesHelper from "../../mixins/FieldStylesHelper";
import CustomDashboardConfig from "@/mixins/CustomDashboardHelper.js";
import NavigationHelper from "@/mixins/navigationHelper";

import { mapGetters } from "vuex";
export default {
  props: ["component", "index", "hide_options"],
  mixins: [FieldStylesHelper, NavigationHelper, CustomDashboardConfig],
  data() {
    return {
      page: 1,
      limit: 100,
      notificationsData: [],
      hasMore: false,
      entity_id: null,
      loading: false,
      loadMoreText: "Load more...",
    };
  },
  async mounted() {
    await this.getNecessaryInfo();
  },
  computed: {
    ...mapGetters("auth", ["getActiveContactType", "getGlobalFiltervalue"]),
  },
  methods: {
    getNotificationTime(notification) {
      const createdAt = new Date(notification.created_at);
      const updatedAt = new Date(notification.updated_at);

      const isAddedNotification = notification?.events?.includes("ADDED");
      if (isAddedNotification || (updatedAt == createdAt)) {
        return notification.created_at;
      }
      return notification.updated_at;
    },
    async loadMore() {
      this.loadMoreText = "Loading...";
      this.page++;
      await this.getNecessaryInfo();
      this.loadMoreText = "Load more items...";
    },
    async getNecessaryInfo(isRefresh = false) {
      if (this.$route.name != "entity-custom-dashboard-config") {
        this.setApplicationUserFilters();
      }
      if (isRefresh) {
        this.page = 1;
        this.notificationsData = [];
      }
      this.loading = true;
      this.entity_id = this.component.notifications[0].entity_id;
      if (this.getGlobalFiltervalue) {
        this.component.globalFilter = this.addGlobalFilters(
          [],
          this.entity_id,
          this.checkGlobalFilter
        );
      }
      let responseData = await postAPICall(
        "POST",
        `/entities/notifications?page=${this.page}&limit=${this.limit}`,
        this.component
      );
      this.resetNotificationFilters();
      this.notificationsData = [
        ...this.notificationsData,
        ...responseData.data,
      ];
      this.hasMore = responseData.hasMore;
      this.loading = false;
    },
    editComponent() {
      this.$emit("editComponent", this.index);
    },
    deleteComponent() {
      this.$confirm(
        "Are you sure to delete the Notification component?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        this.$emit("deleteComponent", this.index);
      });
    },
    redirect(notification) {
      if (
        !["custom-dashboard-config", "entity-custom-dashboard-config"].includes(
          this.$route.name
        )
      ) {
        let routerData;
        if (
          [
            "application-user-dashboard",
            "application-user-page-dashboard",
          ].includes(this.$route.name)
        ) {
          if (notification?.formbuilder_id) {
            routerData = this.$router.resolve(
              `/ap/fb/${notification.formbuilder_code}/${notification.form_builder_data_id}`
            );
          } else {
            let query = this.getNavigationQuery(this.$route.query);
            routerData = this.$router.resolve({
              path: `/ap/entity-view/${notification.entity_id}?key=${Math.floor(
                Math.random() * 100000
              )}&dataId=${notification._id}&fromCustom=true`,
              query: {
                ...query,
                type: "AUfYWb7SC6U=",
              },
            });
          }
        } else {
          if (notification?.formbuilder_id) {
            routerData = this.$router.resolve(
              `/fb/${notification.formbuilder_code}/${notification.form_builder_data_id}`
            );
          } else {
            let query = this.getNavigationQuery({
              dataId: notification._id,
              ...this.$route.query,
            });
            routerData = this.$router.resolve({
              path: `/entity/view/${notification.entity_id}`,
              query: {
                ...query,
              },
            });
          }
        }
        window.open(routerData.href, "_blank");
      }
    },
    setApplicationUserFilters() {
      this.component.notifications.map((notification) => {
        if (
          notification?.relationship_id &&
          !notification?.relationship_id.includes("@")
        ) {
          notification["customFilters"] = [
            {
              data_type: "RELATION",
              field: notification.relationship_id.includes("#")
                ? "nested#related_to/"
                : "self#related_to",
              operator: "in",
              query_type: "AND",
              nested_related_id: notification.relationship_id.includes("#")
                ? notification.relationship_id.split("#")[0]
                : "",
              relation_entity_id: this.getActiveContactType?.contact_type?._id,
              value: [this.getActiveContactType?.account_data_id],
            },
          ];
        }
      });
    },
    resetNotificationFilters() {
      this.component.notifications = this.component.notifications.map((n) => {
        delete n["customFilters"];
        return n;
      });
    },
  },
  watch: {
    getGlobalFiltervalue: {
      async handler() {
        if (this.checkGlobalFilter?.apply_on) {
          this.loading = true;
          if (this.getGlobalFiltervalue) {
            this.component.globalFilter = this.addGlobalFilters(
              [],
              this.entity_id,
              this.checkGlobalFilter
            );
          }else{
            delete this.component.globalFilter
          }
          let responseData = await postAPICall(
            "POST",
            `/entities/notifications?page=${this.page}&limit=${this.limit}`,
            this.component
          );
          this.resetNotificationFilters();
          this.notificationsData = [...responseData.data];
          this.hasMore = responseData.hasMore;
          this.loading = false;
        }
      },
    },
  },
};
</script>
<style>
.custom-dashboard-notifications {
  border: 1px solid #eaeaea;
  min-height: 370px !important;
  margin-bottom: 30px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1) !important;
  border-radius: 5px;
  background-color: #ffffff;
}
.el-card__body,
.el-main {
  padding: 10px;
}
.date-time {
  font-style: normal;
  min-width: 100px;

  @media (max-width: 499.98px) {
    min-width: 70px !important;
  }

  text-align: right;
  color: rgba(0, 0, 0, 0.5) !important;
  font-size: 12px;
}
.notification-icon {
  .icon {
    width: 35px;
    height: auto;

    .primary {
      fill: var(--icon-color) !important;
    }
  }
}
.custom-card:hover {
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
}
</style>
<style scoped>
.scroll-container {
  max-height: 330px;
  overflow-y: auto;
  scrollbar-width: thin;
}
.scroll-container {
  scrollbar-width: none;
}
.scroll-container:hover {
  scrollbar-width: thin;
}
</style>
